<template>
  <div id="import-xml-cte-fical">
    <BreadCrumb :items="breadcrumbItems" />
    <v-card elevation="1" class="pa-2">
      <v-card-title class="header d-flex justify-space-between align-center">
        <h1 class="pa-0">Lista dos processos de importação manual</h1>
        <div class="d-flex">
          <v-btn
            elevation="2"
            class="mx-2"
            color="success"
            large
            :loading="isCreateLoading"
            @click="isOpenManualImport = true"
          >
            Nova Importação
          </v-btn>
        </div>
      </v-card-title>
      <manual-boarding-filters @filterSearch="filterSearch" />

      <v-data-table
        class="mt30 px-5"
        :headers="columnsOptions"
        :items="getManualBoarding"
        :loading="isImportsLoading"
        :items-per-page="paginate.pageSize"
        @update:items-per-page="changeItemsPerPage"
        :footer-props="{
          'items-per-page-options': [10, 20, 30, 50],
          itemsPerPageText: 'Itens por página'
        }"
        no-data-text="Nenhum resultado encontrado"
      >
        <template v-slot:[`item.createdAt`]="{ item }">
          <span> {{ transformDate(item.createdAt) }}</span>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <div class="d-flex" v-if="showActions(item)">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon @click="detailsBoardingImport(item)" dark>
                  <ViewSVG />
                </v-btn>
              </template>
              <span>Detalhes</span>
            </v-tooltip>
            <v-tooltip v-if="item.stepName != 'Concluído'" top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon @click="openDeleteDialog(item)" dark>
                  <TrashSVG />
                </v-btn>
              </template>
              <span>Descartar</span>
            </v-tooltip>
          </div>
        </template>
      </v-data-table>
      <v-pagination v-model="page" :length="paginate.totalPages" :total-visible="7"></v-pagination>
    </v-card>
    <delete-confirm-dialog
      :isOpen.sync="isDeleteDialogOpen"
      :isConfirmBtnLoading="isDeleteButtonLoading"
      @confirmClick="deleteBoarding()"
      title="Descartar processo?"
      :body-text="confirmationDeleteText"
    />
    <import-confirm-dialog
      :isOpen.sync="isOpenManualImport"
      @confirmClick="createBoardingImport()"
      :is-confirm-btn-loading="isCreateLoading"
      title="Criar processo de importação"
      body-text="Você confirma a criação do processo de importação?"
    />
    <MessagesError :errors="errors" :type="errorsType" :error500="error500" @closeMessages="errors = []" />
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState, mapGetters } from 'vuex';
import BreadCrumb from '@/components/BreadCrumb.vue';
import ManualBoardingFilters from '@/components/ManualBoardingImport/ManualBordingFilters.vue';
import MessagesError from '@/components/MessagesError.vue';
import DeleteConfirmDialog from '@/components/ConfirmDialog.vue';
import ImportConfirmDialog from '@/components/ConfirmDialog.vue';
import { FeedbackMessageHandler } from '@/store/modules/feedbackMessageHandler';
import TrashSVG from '@/assets/img/trash.svg';
import ViewSVG from '@/assets/img/view.svg';

export default {
  name: 'ImportsXmlCte',
  components: {
    BreadCrumb,
    ManualBoardingFilters,
    MessagesError,
    DeleteConfirmDialog,
    ImportConfirmDialog,
    ViewSVG,
    TrashSVG
  },
  data: () => ({
    isOpenManualImport: false,
    isImportsLoading: true,
    isCreateLoading: false,
    isDeleteDialogOpen: false,
    isDeleteButtonLoading: false,
    errors: [],
    errorsType: 'error',
    error500: null,
    trashItem: {},
    steps: [
      { position: 1, name: 'Importar NFes', id: '6ef28252-ef1c-4a2a-a941-ea8c1cc2ca03' },
      { position: 2, name: 'Entregas', id: 'bbc452e5-d7b0-4745-bced-a7c652ed9c0d' },
      { position: 3, name: 'Detalhes das entregas', id: '655ac746-cb01-4461-9e8d-710298e23c23' },
      { position: 4, name: 'Paradas', id: 'a37d23f4-b680-420b-8273-1e6a1921b81e' },
      { position: 5, name: 'Cargas', id: 'c292c4b9-dcb4-487b-af53-aa8087fdb4aa' },
      { position: 6, name: 'Embarques', id: '0c428bf3-d0bb-48b2-9d03-d04b0ab8bfc4' },
      {
        position: 7,
        name: 'Confirmação',
        ids: ['f658765e-699c-498b-840a-5455a7d3d2ca', '54a9ebe0-1610-456a-97f0-cc90be72b036']
      }
    ],
    breadcrumbItems: [
      {
        text: 'Início',
        disabled: false,
        to: '/start'
      },
      {
        text: 'Processos de Importação',
        disabled: true
      }
    ],
    columnsOptions: [
      {
        value: 'manualBoardingImportNumber',
        text: 'ID PROCESSO',
        sortable: false
      },
      {
        value: 'responsibleUserName',
        text: 'IMPORTADO POR',
        sortable: false
      },
      {
        value: 'createdAt',
        text: 'DATA IMPORTAÇÃO',
        sortable: false
      },
      {
        value: 'stepName',
        text: 'ETAPA',
        sortable: false
      },
      {
        value: 'actions',
        text: 'AÇÕES',
        sortable: false
      }
    ]
  }),

  computed: {
    ...mapState('ManualBoardingStore', ['paginate']),
    ...mapGetters('ManualBoardingStore', ['getManualBoarding', 'getSteps']),
    ...mapGetters('LoginStore', ['getUserLogged', 'getRole']),
    page: {
      get() {
        return this.paginate.pageNumber;
      },
      set(value) {
        this.setPageNumber(value);

        this.fetchAllManualBoarding();
      }
    },

    confirmationDeleteText() {
      return `Você confirma estar descartando o processo de número: ${this.trashItem.manualBoardingImportNumber}?`;
    }
  },

  mounted() {
    this.fetchAllManualBoarding();
    this.handleFeedback();
  },

  watch: {
    pageNumber: {
      handler() {
        this.fetchAllManualBoarding();
      }
    }
  },

  methods: {
    ...mapMutations('ManualBoardingStore', ['setItemPerPage', 'setPageNumber', 'setStepId']),
    ...mapActions('ManualBoardingStore', [
      'fetchManualBoarding',
      'createManualBoardingImport',
      'fetchSummarySteps',
      'cancelManualBoardingImport'
    ]),

    async fetchAllManualBoarding() {
      this.isImportsLoading = true;
      try {
        await this.fetchManualBoarding();
      } catch (err) {
        console.error(err);
      } finally {
        this.isImportsLoading = false;
      }
    },
    async createBoardingImport() {
      this.isCreateLoading = true;
      try {
        const manualBoardingImportId = await this.createManualBoardingImport();
        this.$router.push(`/imports/manual-boarding-import/${manualBoardingImportId}/step1`);
      } catch (err) {
        console.error(err);
      } finally {
        this.isCreateLoading = false;
      }
    },
    async detailsBoardingImport(item) {
      this.isDetailsLoading = true;
      try {
        if (item.stepName === 'Concluído') {
          this.$router.push(`/imports/manual-boarding-import/${item.id}/details`);
        } else {
          this.setStepId(item.stepsId);
          const step = this.steps.find(
            (x) =>
              x.id === item.stepsId ||
              (Array.isArray(x.ids) && (x.ids[0] === item.stepsId || x.ids[1] === item.stepsId))
          );

          if (!step) {
            console.error('Step not found for stepsId:', item.stepsId);
            return;
          }

          const number = step.position;
          this.$router.push(`/imports/manual-boarding-import/${item.id}/step${number}`);
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.isDetailsLoading = false;
      }
    },
    handleFeedback() {
      const message = FeedbackMessageHandler.getFeedbackMessage(this);
      if (message) {
        this.errorsType = 'success';
        this.errors = [message];
        FeedbackMessageHandler.resetFeedbackMessage(this);
      }
    },
    showActions(item) {
      const userTokenName = this.getUserLogged.userToken.name;
      const isAdmin = this.getRole === 'Admin';
      const isAuthorizedUser = userTokenName === item.responsibleUserName;
      const isAllowedStatus = item.stepName != 'Processando' && item.stepName != 'Descartado';
      return isAllowedStatus && (isAuthorizedUser || isAdmin);
    },
    openDeleteDialog(item) {
      this.trashItem = item;
      this.isDeleteDialogOpen = true;
    },
    async deleteBoarding() {
      try {
        const response = await this.cancelManualBoardingImport([this.trashItem.id]);
        if (response.success) {
          this.errors = ['Processo cancelado com sucesso!'];
          this.errorsType = 'success';
        } else {
          this.errors = response.errors || ['Erro ao cancelar processo'];
          this.errorsType = 'error';
        }
      } catch (error) {
        this.errors = ['Erro ao tentar cancelar o processo. Por favor, tente novamente.'];
        this.errorsType = 'error';
      } finally {
        this.isDeleteDialogOpen = false;
        this.fetchAllManualBoarding();
      }
    },
    filterSearch() {
      this.setPageNumber(1);
      this.fetchAllManualBoarding();
    },
    changeItemsPerPage(items) {
      this.setItemPerPage(items);
      this.fetchAllManualBoarding();
    },
    formatDate(d) {
      if (d === null) return d;
      let dateObj = new Date(`${d}T00:00:00`);
      return dateObj.toLocaleDateString('pt-BR');
    },
    transformDate(date) {
      let dateObj = new Date(`${date}`);
      return `${dateObj.toLocaleDateString('pt-BR')} ${dateObj.toLocaleTimeString('pt-BR')}`;
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep.v-select.v-select--chips .v-select__selections {
  min-height: 50px;
}

::v-deep .v-data-table-header tr th {
  background-color: #e0e0e0 !important;
  border: 1px solid #e0e0e0;
}
</style>
